export default "__VITE_ASSET__BebfMwYG__"